import type { IEquipmentItem } from '@shared/types';

type ITrainerModel = Omit<IEquipmentItem, 'id' | 'categorySlug' | 'number' | 'photos'>;

// Единый контент одинаковых моделей в разных разделах каталога.
// Характеристики пока редакционные: владелец заменит их реальными при поддержке сайта (03.11.2026).
export const TRAINER_MODELS = {
  benchPress: {
    title: 'Жим лёжа',
    description:
      'Рычажный тренажёр для жима из положения лёжа. Предназначен для упражнений на мышцы груди и рук с опорой спины на скамью.',
    specs: [
      { label: 'Ход рукоятей', value: '400 мм' },
      { label: 'Высота сиденья', value: '480 мм' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '180 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/ef6f51db6cc382422e42bcff104bde93',
    videoTitle: 'Жим лёжа',
    setup: [
      'Настраивайте нагрузку до начала упражнения, когда тренажёром никто не пользуется.',
      'Отрегулируйте нагрузку, перемещая стальные обрезиненные диски по направляющей.',
      'У тренажёра два рычага — установите на обоих одинаковую нагрузку.',
      'Начинайте с небольшой нагрузки и увеличивайте её постепенно.',
      'Не используйте тренажёр, если диски самопроизвольно смещаются.',
    ],
    exercises: [
      {
        title: 'Жим лёжа',
        inVideo: true,
        start:
          'Лягте на скамью, прижмите спину и таз, поставьте стопы устойчиво и возьмитесь за рукояти.',
        steps: [
          'Плавно выжмите рукояти от себя до почти полного выпрямления рук.',
          'Медленно верните рукояти, не бросая рычаги на ограничители.',
        ],
        tips: ['Не отрывайте таз и лопатки от скамьи.', 'Выдох — на усилии.'],
      },
    ],
    safetyNote: 'Не допускайте других людей в зону движения рычагов.',
  },
  shoulderPress: {
    title: 'Жим вверх',
    description:
      'Рычажный тренажёр для жима вверх из положения сидя. Рабочие рукояти используются для упражнений на мышцы плечевого пояса и рук.',
    videoUrl: 'https://rutube.ru/play/embed/e45782ebfe3caee9fd9c626929adab4f',
    videoTitle: 'Жим вверх сидя',
    specs: [
      { label: 'Ход рукоятей', value: '450 мм' },
      { label: 'Высота сиденья', value: '480 мм' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    setup: [
      'Настраивайте нагрузку до начала упражнения, когда тренажёром никто не пользуется.',
      'Отрегулируйте нагрузку, перемещая стальные обрезиненные диски по направляющей.',
      'У тренажёра два рычага — установите на обоих одинаковую нагрузку.',
      'Начинайте с небольшой нагрузки и увеличивайте её постепенно.',
      'Не используйте тренажёр, если диски самопроизвольно смещаются.',
    ],
    exercises: [
      {
        title: 'Жим вверх сидя',
        inVideo: true,
        start: 'Сядьте, прижмите спину к спинке и возьмитесь за рукояти на уровне плеч.',
        steps: [
          'Выжмите рукояти вверх до почти полного выпрямления рук.',
          'Медленно опустите рукояти до уровня плеч.',
        ],
        tips: ['Не прогибайтесь в пояснице и не отрывайте спину от спинки.', 'Выдох — на усилии.'],
      },
    ],
    safetyNote: 'Не бросайте рукояти и не допускайте других людей в зону движения рычагов.',
  },
  seatedRow: {
    title: 'Рычажная тяга',
    description:
      'Рычажный тренажёр для тяги к поясу сидя. Рабочие рукояти позволяют выполнять упражнение на мышцы спины и рук с контролем движения корпуса.',
    videoUrl: 'https://rutube.ru/play/embed/e31304e73f3c7b4b8649eec2177a6f2a',
    videoTitle: 'Тяга к поясу сидя',
    specs: [
      { label: 'Ход рукоятей', value: '500 мм' },
      { label: 'Высота сиденья', value: '480 мм' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    setup: [
      'Настраивайте нагрузку до начала упражнения, когда тренажёром никто не пользуется.',
      'Отрегулируйте нагрузку, перемещая стальные обрезиненные диски по направляющей.',
      'У тренажёра два рычага — установите на обоих одинаковую нагрузку.',
      'Начинайте с небольшой нагрузки и увеличивайте её постепенно.',
      'Не используйте тренажёр, если диски самопроизвольно смещаются.',
    ],
    exercises: [
      {
        title: 'Тяга к поясу сидя',
        inVideo: true,
        start:
          'Сядьте лицом к тренажёру, поставьте стопы на площадки, спина прямая. Возьмитесь за рукояти на вытянутых руках.',
        steps: [
          'Потяните рукояти к поясу, сводя лопатки и отводя локти назад вдоль корпуса.',
          'Медленно верните рукояти вперёд до выпрямления рук.',
        ],
        tips: ['Тяните спиной, а не отклонением корпуса назад.', 'Выдох — на усилии.'],
      },
    ],
    safetyNote: 'Не бросайте рукояти и не допускайте других людей в зону движения рычагов.',
  },
  gravitron: {
    title: 'Гравитрон',
    description:
      'Тренажёр с поддерживающей платформой для облегчённых подтягиваний и отжиманий на брусьях. Механизм поддержки помогает освоить движения с собственным весом.',
    specs: [
      { label: 'Ход рукоятей', value: '600 мм' },
      { label: 'Высота', value: '2 300 мм' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/be310f1ca03643acf064257ccb38f810',
    videoTitle: 'Подтягивания и отжимания с поддержкой',
    setup: [
      'Настраивайте противовес до начала упражнения, когда тренажёром никто не пользуется.',
      'Установите противовес, перемещая обрезиненные диски по направляющей: чем он больше, тем легче подтягиваться и отжиматься.',
      'Подберите противовес по своим возможностям; если не знаете, какую настройку выбрать, обратитесь к инструктору.',
      'Не используйте тренажёр, если диски самопроизвольно смещаются.',
    ],
    exercises: [
      {
        title: 'Подтягивание с поддержкой',
        inVideo: true,
        start:
          'Встаньте на подвижную опору для ног и возьмитесь за верхние рукояти хватом сверху, руки выпрямлены.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше рукоятей; опора под ногами помогает подъёму.',
          'Медленно опуститесь до выпрямления рук.',
        ],
        tips: [
          'Поддержка облегчает движение — удобно, чтобы освоить подтягивания.',
          'Без рывков и раскачивания.',
        ],
      },
      {
        title: 'Отжимания на брусьях с поддержкой',
        inVideo: true,
        start:
          'Встаньте на подвижную опору для ног и возьмитесь за нижние рукояти-брусья, руки выпрямлены.',
        steps: [
          'Согните руки, опуская корпус, пока плечо не окажется примерно на уровне локтя.',
          'Выпрямите руки, поднимая корпус в упор.',
        ],
        tips: ['Не опускайтесь глубже, чем позволяет подвижность плеч.'],
      },
    ],
    safetyNote:
      'Сходите с опоры, только когда она остановилась, и продолжайте держаться за рукояти.',
  },
  hyperextension: {
    title: 'Гиперэкстензия',
    description:
      'Сдвоенный тренажёр: опоры для гиперэкстензии и наклонная скамья для подъёма туловища. Используется для упражнений на мышцы спины, задней поверхности тела и пресса.',
    specs: [
      { label: 'Угол платформы', value: '45°' },
      { label: 'Длина', value: '1 400 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/7a1e57755e4a40326e904cb74a3bcb6f',
    videoTitle: 'Подъём туловища на скамье и гиперэкстензия',
    exercises: [
      {
        title: 'Подъём туловища на наклонной скамье',
        inVideo: true,
        start:
          'Сядьте на наклонную скамью, закрепите ноги в штатных упорах и плавно лягте на спину; руки скрещены на груди.',
        steps: [
          'Поднимите туловище усилием мышц живота.',
          'Плавно опуститесь, не ударяясь спиной о скамью.',
        ],
        tips: ['Не тяните голову руками.', 'Выдох — на подъёме.'],
      },
      {
        title: 'Гиперэкстензия',
        inVideo: true,
        start:
          'Расположитесь лицом вниз и закрепите ноги в штатных упорах: опора под верхней частью бёдер, сгибаться в тазобедренных суставах ничто не мешает. Руки скрещены на груди, корпус и ноги — одна линия.',
        steps: [
          'Медленно наклоните корпус вниз, сгибаясь в тазобедренных суставах.',
          'Поднимите корпус до прямой линии с ногами.',
        ],
        tips: ['Не запрокидывайтесь выше прямой линии.', 'Двигайтесь плавно, без рывков.'],
      },
    ],
    safetyNote: 'Перед первым занятием попросите инструктора проверить положение на опорах.',
  },
  exerciseBike: {
    title: 'Велотренажёр',
    description:
      'Уличный велотренажёр с сиденьем, спинкой и ножными педалями. Используется для разминки и равномерной кардионагрузки в положении сидя.',
    specs: [
      { label: 'Высота сиденья', value: '520 мм' },
      { label: 'Привод', value: 'Ножной' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '120 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/ef90d81eceedb9d64df7b9bcc473cdfa',
    videoTitle: 'Вращение педалей сидя',
    setup: [
      'Отрегулируйте сиденье по росту до начала занятия.',
      'Сядьте и поставьте стопу на педаль в дальней точке: нога должна быть почти выпрямлена, колено слегка согнуто.',
      'Перед вращением педалей проверьте, что сиденье надёжно зафиксировано.',
    ],
    exercises: [
      {
        title: 'Вращение педалей сидя',
        inVideo: true,
        start: 'Сядьте с опорой спины, поставьте стопы на педали и возьмитесь за рукояти.',
        steps: [
          'Начните медленно вращать педали.',
          'Держите ровный удобный темп, корпус неподвижен.',
          'Плавно замедлитесь и полностью остановите педали, прежде чем встать.',
        ],
        tips: ['Подходит для разминки и спокойной кардионагрузки.'],
      },
    ],
    safetyNote: 'Не вставайте на педали и не останавливайте их руками.',
  },
  cycleElliptical: {
    title: 'Велоорбитрек',
    description:
      'Кардиотренажёр с сиденьем, спинкой и ножными педалями. Используется для вращения педалей сидя. Неподвижные передние рукояти служат опорой для рук.',
    specs: [
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '120 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/4f345bc7081b89d0e52ccfcfbf483fb7',
    videoTitle: 'Вращение педалей сидя',
    setup: [
      'Отрегулируйте сиденье по росту до начала занятия.',
      'Сядьте и поставьте стопу на педаль в дальней точке: нога должна быть почти выпрямлена, колено слегка согнуто.',
      'Перед вращением педалей проверьте, что сиденье надёжно зафиксировано.',
    ],
    exercises: [
      {
        title: 'Вращение педалей сидя',
        inVideo: true,
        start: 'Сядьте с опорой спины, поставьте стопы на педали и возьмитесь за передние рукояти.',
        steps: [
          'Начните медленно вращать педали, держась за неподвижные рукояти.',
          'Держите ровный удобный темп, сохраняя спину на опоре.',
          'Плавно замедлитесь и полностью остановите педали, прежде чем встать.',
        ],
        tips: ['Подходит для разминки и спокойной кардионагрузки.'],
      },
    ],
    safetyNote: 'Сходите после полной остановки педалей. Не вставайте на подвижные педали.',
  },
  ellipticalTrainer: {
    title: 'Эллиптический тренажёр',
    description:
      'Уличный кардиотренажёр с опорными платформами для стоп и подвижными рукоятями. Используется для согласованного циклического движения рук и ног.',
    videoUrl: 'https://rutube.ru/play/embed/bedbbc2b782b65b51ffd034cb53ead81',
    videoTitle: 'Ходьба на эллиптическом тренажёре',
    specs: [
      { label: 'Длина шага', value: '400 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '120 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Ходьба на эллиптическом тренажёре',
        inVideo: true,
        start:
          'Держась за рукояти, поочерёдно встаньте на платформы; стопы стоят на них полностью, корпус прямой.',
        steps: [
          'Начните медленное согласованное движение ногами и руками.',
          'Постепенно увеличьте темп до удобного и держите его ровным.',
          'Плавно замедлитесь и полностью остановите платформы, прежде чем сойти.',
        ],
        tips: ['Хорошо подходит для разминки перед силовыми упражнениями.'],
      },
    ],
    safetyNote: 'Не сходите с движущихся платформ. На тренажёре занимается один человек.',
  },
} satisfies Record<string, ITrainerModel>;
